import { render, staticRenderFns } from "./RemunerationStatements.vue?vue&type=template&id=9418cdc2&"
import script from "./RemunerationStatements.vue?vue&type=script&lang=js&"
export * from "./RemunerationStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports